import workspaceQuery from '../../../graphql/queries/product/BinReplenishmentHeaderWorkspaceQuery.graphql';
import fragment from '../../../graphql/fragments/product/BinReplenishmentHeaderFragment.graphql';
import { EntityType } from '../../../@types/entityTypes';

const BinReplenishmentHeader: EntityType = {
  type: 'BinReplenishmentHeader',
  title: 'Bin Replenishment Summary',
  formTitle: 'Bin Replenishment Summary',
  workspaceUrl: '/Products/StockControl/Replenishment/Workspace/',
  workspace: workspaceQuery,
  fragment,
  screenReference: 'BIN_REPLENISHMENT_HEADER',
  formURL: '/Products/StockControl/ReplenishmentDetail/Workspace/:jobid/',
};

export default BinReplenishmentHeader;
